<template lang="pug">
span.y-chip(:class="[chipClass, textSize, color, outlinedClass]" :style="widthStyle")
  slot(name="prepend")
  slot(name="text")
    span(:class="[textColor ? `${textColor}--text` : '', truncated ? 'ellipsis-text-1' : '']") {{ label }}
  slot
  slot(name="append")
  
</template>

<script>
export default {
  name: 'YChip',
  props: {
    label: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'normal'
    },
    textColor: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'sm'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    chipClass: {
      type: String,
      default: null
    },
    truncated: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
  },
  computed: {
    textSize () {
      switch (this.size) {
        case 'xxs':
          return 'text-xxs'
        case 'xs':
          return 'text-xs'
        case 'sm':
          return 'text-sm'
        case 'md':
          return 'text-md'
        default:
          return 'text-sm'
      }
    },
    outlinedClass () {
      return this.outlined ? 'outlined' : ''
    },
    widthStyle () {
      if (!this.width) return {}
      return {
        maxWidth: typeof this.width === 'number' ? `${this.width}px` : this.width
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.y-chip {
  border-radius: 6px;
  display: inline-flex;
  position: relative;
  align-items: center;
  vertical-align: middle;
  padding: 2px 5px;
}
.height-24 {
  height: 24px;
}
.height-18 {
  height: 18px;
}
.normal {
  background: #F9FAFB !important;
  color: #333333 !important;
}
.red {
  background: #FFEBEB !important;
  color: #B52222 !important;
}
.green {
  background: #EEFCE9 !important;
  color: #1A7935 !important;
}
.orange {
  background: #FFF7D9 !important;
  color: #CA6C16 !important;
}
.grey {
  background: #848484 !important;
  color: #FFFFFF !important;
}
.blue {
  background: #F0F8FF !important;
  color: #3570CA !important;
}
.outlined {
  border: 1px solid #EEEEEE !important;
}
</style>